document.addEventListener( 'DOMContentLoaded', function () {
	document.querySelectorAll( '.mu-accordion' ).forEach( ( accordion, accIndex ) => {
		accordion.querySelectorAll( '.accordion-item' ).forEach( ( item, index ) => {
			const heading = item.querySelector( '.accordion-header' );
			const button = item.querySelector( '.accordion-button' );
			const collapse = item.querySelector( '.accordion-collapse' );

			if ( heading && button && collapse ) {
				const uniqueId = `faq-${ accIndex }-${ index + 1 }`;

				// Assign IDs to heading
				heading.id = `${ uniqueId }-heading`;

				// Button attributes
				button.setAttribute( 'data-bs-toggle', 'collapse' );
				button.setAttribute( 'data-bs-target', `#${ uniqueId }-collapse` );
				button.setAttribute( 'aria-controls', `${ uniqueId }-collapse` );
				button.setAttribute( 'aria-expanded', index === 0 ? 'true' : 'false' );

				// Collapse attributes
				collapse.id = `${ uniqueId }-collapse`;
				collapse.setAttribute( 'aria-labelledby', `${ uniqueId }-heading` );
				collapse.setAttribute( 'data-bs-parent', `#accordion-${ accIndex }` );

				// Keep only the first item open
				if ( index === 0 ) {
					collapse.classList.add( 'show' );
				} else {
					collapse.classList.remove( 'show' );
				}
			}
		} );

		// Add a unique ID to the accordion group for data-bs-parent
		accordion.querySelector( '.accordion' ).id = `accordion-${ accIndex }`;
	} );
} );
